import httpClient from '../api/httpClient'

const BASE_URL = '/refvideos'

export const getPersonVideos = (payload) => httpClient.get(`${BASE_URL}/${payload.deceasedId}/videos?pageSize=${payload.pageSize}&pageNumber=${payload.pageIndex}`)

export const getPersonVideoById = ({ personId, entityId }) => 
  httpClient.get(`${BASE_URL}/${personId}/video/${entityId}`)

export const deletePersonVideo = (payload) => 
  httpClient.delete(`${BASE_URL}/delete`, { data: { Id: payload } })

export const updateVideoDetails = (payload) => 
  httpClient.put(`${BASE_URL}/update`, payload)

export const getVideosOrder = (payload) => httpClient.get(`${BASE_URL}/${payload}/allvideosname`)

export const saveVideosOrder = (payload) => httpClient.put(`${BASE_URL}/updateOrder`, payload)

export default {
  getPersonVideos,
  getPersonVideoById,
  deletePersonVideo,
  updateVideoDetails,
  getVideosOrder,
  saveVideosOrder
}
